import { ComponentProps, forwardRef, useState } from 'react';
import { Input, Label } from 'react-aria-components';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

type Props = {
  title: string;
  required: boolean;
  supportText?: string;
  disabled?: boolean;
  options: { id: string; label: string; value: string }[];
  register?: UseFormRegisterReturn;
  errors?: FieldError | undefined;
  initialChecked?: string;
};

type ChildProps = ComponentProps<'input'> & Props;

const RadioGroup = forwardRef<HTMLInputElement, ChildProps>(
  (
    { title, required, options, supportText, register, disabled, errors, initialChecked, ...props },
    ref
  ) => {
    const [activeRadio, setActiveRadio] = useState<string>(
      initialChecked ? initialChecked : options[0].value
    );

    return (
      <div className="flex flex-col space-y-2">
        <div>
          <Label className="mb-2 text-lg font-bold">{title}</Label>
          {required && <span className="mb-2 ml-1 text-red-800">※必須</span>}
        </div>
        {supportText && <span className="mb-2 text-sm text-gray-500">{supportText}</span>}
        <div className="flex flex-row items-center justify-between">
          {options.map((option) => (
            <Label
              className="px-2"
              key={option.label}
              onClick={() => setActiveRadio(option.value)}
            >
              <Input
                className="mr-2"
                id={option.id}
                name={title}
                type="radio"
                disabled={disabled}
                defaultChecked={option.value === activeRadio}
                value={option.value}
                ref={ref}
                {...register}
                {...props}
              />
              {option.label}
            </Label>
          ))}
        </div>
        <div className="mb-2 w-fit text-sm text-red-800">{errors?.message}</div>
      </div>
    );
  }
);

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
